var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1940_342962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8511 3.35938L1.8468 14.3645C1.79144 14.42 1.75146 14.4901 1.73242 14.5654L0.512705 19.4611C0.476219 19.6085 0.519526 19.7652 0.627078 19.8728C0.708456 19.9542 0.81934 19.9992 0.932762 19.9992C0.967502 19.9992 1.00304 19.9949 1.03762 19.9862L5.93331 18.7663C6.00961 18.7473 6.07893 18.7075 6.1343 18.6521L17.1395 7.64783L12.8511 3.35938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8657 1.85821L18.6407 0.633258C17.822 -0.185441 16.3951 -0.184648 15.5774 0.633258L14.0769 2.13376L18.3652 6.42205L19.8657 4.92155C20.2746 4.51276 20.4999 3.96865 20.4999 3.38996C20.4999 2.81127 20.2746 2.26716 19.8657 1.85821Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1940_342962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.3588ddb56b88cfacded0ed5328b571c6.svg";
export { ForwardRef as ReactComponent };